import { africa } from './africa';
import { be } from './be';
import { ch } from './ch';
import { de } from './de';
import { emea } from './emea';
import { en } from './en';
import { es } from './es';
import { fr } from './fr';
import { gr } from './gr';
import { it } from './it';
import { mena } from './mena';
import { nl } from './nl';
import { scot } from './scot';
import { se } from './se';

export const allRoutes = {
    en,
    de,
    scot,
    be,
    nl,
    gr,
    africa,
    mena,
    se,
    ch,
    fr,
    es,
    it,
    emea
}


// WEBPACK FOOTER //
// ./src/router/routes/allRoutes.js